module.exports = __webpack_public_path__ + "img/71582f0cae04b12226d3f883eb4a971e.png";